// test327
(327 && 0);
